import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HERO_VIDEO_URL } from '../data/camp-data';
import CountdownTimer from './CountdownTimer';

export default function HeroLanding({ onEnter }) {
  const [isExiting, setIsExiting] = useState(false);

  const handleEnter = () => {
    setIsExiting(true);
    setTimeout(() => onEnter(), 1200);
  };

  return (
    <AnimatePresence>
      {!isExiting ? (
        <motion.div
          className="relative w-full h-screen overflow-hidden"
          exit={{ opacity: 0, scale: 1.1 }}
          transition={{ duration: 1.2, ease: 'easeInOut' }}
          data-testid="hero-landing"
        >
          {/* Background Video */}
          <video
            autoPlay
            muted
            loop
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
            data-testid="hero-video"
          >
            <source src={HERO_VIDEO_URL} type="video/mp4" />
          </video>

          {/* Overlay */}
          <div className="absolute inset-0 video-overlay" />

          {/* Scanline effect */}
          <div className="absolute inset-0 scanline pointer-events-none" />

          {/* Content */}
          <div className="relative z-10 flex flex-col items-center justify-center h-full px-4">
            {/* Main Title */}
            <motion.h1
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.6, duration: 1, ease: 'easeOut' }}
              className="font-heading text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter text-center neon-text uppercase"
            >
              MUY COMPLICADO
            </motion.h1>

            {/* OKTOBER FEST - bigger */}
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.2, duration: 0.8 }}
              className="font-heading text-5xl sm:text-7xl lg:text-9xl font-black tracking-tight text-center uppercase mt-2"
              style={{
                color: '#FFD700',
                textShadow: '0 0 20px rgba(255, 215, 0, 0.5), 0 0 40px rgba(255, 215, 0, 0.3), 0 0 80px rgba(255, 215, 0, 0.15)',
              }}
            >
              OKTOBER FEST
            </motion.h2>

            {/* Dirty Version - removed */}

            {/* Subtitle */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.8, duration: 1 }}
              className="mt-6 text-base sm:text-lg text-[var(--mc-text-sec)] text-center max-w-lg leading-relaxed"
            >
              Welcome to something you can not explain
            </motion.p>

            {/* Countdown Timer */}
            <div className="mt-8">
              <CountdownTimer />
            </div>

            {/* Portal Button */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 2.5, duration: 0.8 }}
              className="mt-12"
            >
              <button
                onClick={handleEnter}
                data-testid="portal-enter-button"
                className="relative group cursor-pointer"
              >
                <div className="absolute inset-0 rounded-full portal-glow opacity-60 group-hover:opacity-100 transition-opacity duration-500" 
                     style={{ margin: '-12px' }} />
                <div className="relative glass rounded-full px-10 py-4 
                            border border-[var(--mc-pink)]/30
                            group-hover:border-[var(--mc-pink)]/60
                            transition-all duration-500 group-hover:scale-105">
                  <span className="font-heading text-sm tracking-[0.2em] uppercase text-[var(--mc-pink)] group-hover:text-white transition-colors duration-300">
                    Join the Party!
                  </span>
                </div>
              </button>
            </motion.div>

            {/* Hint */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.3 }}
              transition={{ delay: 3.5, duration: 2 }}
              className="absolute bottom-8 text-[10px] tracking-[0.2em] uppercase text-[var(--mc-text-muted)]"
            >
              the portal awaits
            </motion.p>
          </div>
        </motion.div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="fixed inset-0 z-50 bg-[var(--mc-bg)] flex items-center justify-center"
        >
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: [0, 3, 0.5], opacity: [0, 1, 0] }}
            transition={{ duration: 1.2, ease: 'easeInOut' }}
            className="w-32 h-32 rounded-full"
            style={{
              background: 'radial-gradient(circle, #FFD700, var(--mc-pink), transparent)',
              filter: 'blur(20px)',
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
